//import { signin, me } from '@app/api/bible'
const bible = require('@/api/bible')
const user = require('@/api/user')
//import { signin, me } from '@app/api/data'
import { getToken, setToken, removeToken } from '@/utils/data'
import moment from 'moment'

const data = {
  state: {
    time: 0,
    info: {
      auth: [
        { value: '000', text: 'なし', },
        { value: '100', text: '一般', },
        { value: '200', text: '管理者', },
        { value: '300', text: '特権管理者', },
      ],
      lang: {
      },
    },
    list: {
      users: {
        value: '',
        items: [
        ],
        response: null,
        connecting: false,
      },
      news: {
        value: '',
        items: [
        ],
        response: null,
        connecting: false,
      },
      contracts: {
        value: '',
        items: [
        ],
        response: null,
        connecting: false,
      },
    }
  },

  mutations: {
    UPDATE_TIME: (state) => {
      state.time = moment().valueOf()
    },
    SET_LIST_RESPONSE: (state, data) => {
      if (data.response) {
        state.list[data.type].response = data.response
        state.list[data.type].items = state.list[data.type].items.concat(data.response.data.item)
      } else {
        state.list[data.type].response = null
        state.list[data.type].items = []
      }
    },
    UPDATE_LIST_ITEM: (state, data) => {
      for (let i = 0; i < state.list[data.type].items.length; i++) {
        if (state.list[data.type].items[i].id === data.item.id) {
          state.list[data.type].items.splice(i, 1, Object.assign({}, state.list[data.type].items[i], data.item))
          break
        }
      }
    },
    REMOVE_LIST_ITEM: (state, data) => {
      for (let i = 0; i < state.list[data.type].items.length; i++) {
        if (state.list[data.type].items[i].id === data.id) {
          state.list[data.type].items.splice(i, 1)
          break
        }
      }
    },
  },

  actions: {
    dataUpdateTime({ commit, state }) {
      commit('UPDATE_TIME')
    },
    dataUserSearch({ commit, state }, { form, skip }) {
      return new Promise((resolve, reject) => {
        if (!skip) {
          commit('SET_LIST_RESPONSE', { type: 'users', response: null, })
        }

        state.list.users.connecting = true
        user.search(form, skip).then(response => {
          commit('SET_LIST_RESPONSE', { type: 'users', response: response, })
          resolve(response)
        }).catch(error => {
          reject(error)
        }).then(() => {
          state.list.users.connecting = false
        })
      })
    },

    dataUserReady({ commit, state }, item) {
      return new Promise((resolve, reject) => {
        user.ready(item).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    dataUserActive({ commit, state }, item) {
      return new Promise((resolve, reject) => {
        user.active(item).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    dataUserUpdate({ commit, state }, item) {
      return new Promise((resolve, reject) => {
        user.update(item).then(response => {
          commit('UPDATE_LIST_ITEM', { type: 'users', item: Object.assign({}, response.data, { password: null, }), })
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    dataUserRemove({ commit, state }, { id }) {
      return new Promise((resolve, reject) => {
        user.remove(id).then(response => {
          commit('REMOVE_LIST_ITEM', { type: 'users', id: id, })
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    dataUpdateListItem({ commit, state }, item) {
      return new Promise((resolve, reject) => {
        commit('UPDATE_LIST_ITEM', { type: 'users', item: item, })
        resolve()
      })
    },
  }
}

export default data
